import React, { useState } from 'react';
import {
  Button, Grid, IconButton, TextField, Typography,
} from '@material-ui/core';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { empty, getLocalTimezone, getUtcFromTimezone } from '../helpers/untils';
import { getDefaultSharedTextForClipboard } from '../helpers/misc';
import { DEVICE_USAGE_TYPE } from '../config/constant';

const LOCAL_TIMEZONE = getLocalTimezone()

// Share form for delivery devices: the owner only shares the car location for a
// limited time, so there is no trip / upload requirement setting here.
const ShareDeliveryFilter = (props) => {
  const { handleSubmit, selectedDevice, apiLoading, generatedUrl, showToast, copyTextClipboard } = props

  const user = useSelector((state) => state.session.user);

  const [shareMinutes, setShareMinutes] = useState(60)

  const getDeviceShareSettings = () => {
    try {
      return empty(selectedDevice?.share_settings) ? {} : JSON.parse(selectedDevice.share_settings)
    } catch (e) {
      return {}
    }
  }

  const sharedTextTemplate = getDeviceShareSettings()['sharedTextTemplate'] || getDefaultSharedTextForClipboard()

  const onClickGenerate = () => {
    const minutes = Number(shareMinutes)
    if (empty(shareMinutes) || isNaN(minutes) || minutes <= 0) {
      alert("Please enter how many minutes the location is shared for")
      return false
    }
    const timezone = LOCAL_TIMEZONE
    if (empty(timezone) || timezone.includes('GMT+') || timezone.includes('GMT-')) { // allow only area/city timezone
      alert(`Select TimeZone!`)
      return false
    }

    const from = moment()
    const to = moment().add(minutes, 'minutes')

    // keep the settings already saved on the device (they are reused if the car
    // ever goes back to rental) and only force what a delivery link needs.
    const shareSetting = {
      ...getDeviceShareSettings(),
      share_setting_enabled: false,
      useSecondDomain: false,
      deviceId: selectedDevice['id'],
      usage_type: DEVICE_USAGE_TYPE.DELIVERY,
      share_location_minutes: minutes,
      sharedTextTemplate: sharedTextTemplate,
    }

    var form_data = new FormData();
    form_data.append("shareSetting", JSON.stringify(shareSetting));
    form_data.append("user_id", user.id);
    form_data.append("device_id", selectedDevice['id']);
    form_data.append("deviceId", selectedDevice['id']);
    form_data.append("timezone", timezone);
    form_data.append("from", getUtcFromTimezone(from.format('YYYY-MM-DD HH:mm:ss'), timezone).toISOString());
    form_data.append("from_local", from.format('YYYY-MM-DD HH:mm:ss'));
    form_data.append("to", getUtcFromTimezone(to.format('YYYY-MM-DD HH:mm:ss'), timezone).toISOString());
    form_data.append("to_local", to.format('YYYY-MM-DD HH:mm:ss'));
    form_data.append("share_minutes_before", 0);
    form_data.append("share_minutes_after", 0);
    form_data.append("allot_per_day", 0);
    form_data.append("selectedGeofenceIds", JSON.stringify([]));

    handleSubmit(form_data)
  }

  const onClickCopyUrl = () => {
    if (generatedUrl) {
      copyTextClipboard(generatedUrl, sharedTextTemplate)
      showToast("Link has been copied…")
    }
  }

  return (
    <Grid container spacing={2} justifyContent="flex-start">
      <Grid item xs={12} sm={12}>
        <Stack direction={`row`} alignItems={`center`} spacing={1.5}>
          <Typography>Share location for</Typography>
          <TextField
            variant="filled"
            label=""
            value={shareMinutes}
            onChange={(e) => setShareMinutes(e.target.value)}
            style={{ width: '100px' }}
            inputProps={{ type: 'number', min: 1, placeholder: "" }}
          />
          <Typography>Minutes</Typography>
        </Stack>
      </Grid>

      <Grid item xs={12} sm={12}>
        <Button
          onClick={() => onClickGenerate()}
          variant="outlined"
          color="secondary"
          disabled={apiLoading}
        >
          Generate
        </Button>
      </Grid>

      {
        (generatedUrl) && (
          <Grid item xs={12} sm={12}>
            <Stack direction={`row`} spacing={1} alignItems={`center`}>
              <TextField
                fullWidth
                label={`Generated URL`}
                value={generatedUrl}
                readOnly={true}
                variant="filled"
              />
              <IconButton onClick={() => onClickCopyUrl()} title={`Copy`}>
                <ContentCopyIcon />
              </IconButton>
            </Stack>
          </Grid>
        )
      }
    </Grid>
  )
}

export default ShareDeliveryFilter;
